export const odysseyEndpoints = {
    sales: {
        orders: {
            api: '/api/odyssey/orders/sales/seller-orders',
            method: 'GET',
            parameter: false
        },
        ordersShippingFulfillment: {
            api: '/api/odyssey/orders/sales/seller-orders-shipping-fulfillment',
            method: 'GET',
            parameter: false
        },
        products: {
            api: '/api/odyssey/orders/sales/products',
            method: 'GET',
            parameter: true
        },
        details: {
            api: '/api/odyssey/orders/sales/details',
            method: 'GET',
            parameter: true
        },
        tracking: {
            api: '/api/odyssey/orders/sales/tracking',
            method: 'POST',
            parameter: true
        },
        reports: {
            api: '/api/odyssey/orders/items/list-all/seller-transactions',
            method: 'GET',
            parameter: false
        },
        generateCSV: {
            api: '/api/odyssey/orders/items/list-all/seller-transactions/csv',
            method: 'POST',
            parameter: true
        },
        returnReports: {
            api: '/api/odyssey/order/return/items/list-all/seller-transactions',
            method: 'GET',
            parameter: false
        },
        generatedReports: {
            api: "/api/odyssey/download/report/available/history",
            method: "GET",
            parameter: false,
        },
        generateReturnCSV: {
            api: '/api/odyssey/order/return/items/list-all/seller-transactions/csv',
            method: 'POST',
            parameter: true
        },
        generateReport: {
            api: '/api/odyssey/orders/items/list-all/seller-transactions/csv',
            method: 'GET',
            parameter: true
        },
        generateSingleUseCouponReport: {
            api: '/api/odyssey/orders/items/seller-transactions/single-use/csv',
            method: 'GET',
            parameter: true
        },
        returnDetails: {
            api: '/api/odyssey/order/return/detailsBySalesOrderId',
            method: 'GET',
            parameter: true
        },
        sellerOrders: {
            api: '/api/odyssey/orders/sales/details/seller-orders',
            method: 'GET',
            parameter: false
        },
        saleItems: {
            api: '/api/odyssey/seller-orders/items/names',
            method: 'GET',
            parameter: true
        },
        courrier: {
            api: '/api/odyssey/configuration/dictionary',
            method: 'GET',
            parameter: true
        },
        downloadFspInvoice: {
            api: '/api/odyssey/download-fsp-invoice',
            method: 'GET',
            parameter: true
        },
        sendFspInvoice: {
            api: '/api/odyssey/send-fsp-invoice',
            method: 'GET',
            parameter: true
        }
    },
    settlements: {
        totalEarnings: {
            api: '/api/order/settlements/total-earnings-seller',
            method: 'GET',
            parameter: true
        },
        list: {
            api: '/api/order/settlements/list',
            method: 'GET',
            parameter: true
        },
        settlementDetails: {
            api: '/api/order/settlements/batchDetails',
            method: 'GET',
            parameter: true
        },
        settlementDetailsById: {
            api: '/api/order/settlements/settlementDetails',
            method: 'GET',
            parameter: true
        },
        listForPlatformUsers: {
            api: '/api/order/settlements/list-all',
            method: 'GET',
            parameter: true
        },
        listForPlatformUsersByKey: {
            api: '/api/order/settlements/list-platform',
            method: 'GET',
            parameter: true
        },
        sellerSummary: {
            api: '/api/order/settlements/summary',
            method: 'GET',
            parameter: true
        },
        generateCSVbyId: {
            api: '/api/order/settlements/report',
            method: 'GET',
            parameter: true
        },
        generateCSV: {
            api: '/api/order/settlements/report',
            method: 'POST',
            parameter: true
        },
        submitSettlement: {
            api: '/api/order/settlements/settle',
            method: 'POST',
            parameter: true
        }
    },
    returns: {
        getOrderDetailsById: {
            api: '/api/odyssey/orders/sales/byID',
            method: 'GET',
            parameter: true
        },
        listByStatus: {
            api: '/api/odyssey/order/return/list',
            method: 'GET',
            parameter: false
        },
        approveReturn: {
            api: '/api/odyssey/order/return/approve',
            method: 'POST',
            parameter: false
        },
        rejectReturn: {
            api: '/api/odyssey/order/return/reject',
            method: 'POST',
            parameter: false
        }

    },
    config: {
        dictionary: {
            api: '/api/odyssey/configuration/dictionary',
            method: 'GET',
            parameter: false
        }
    },
    supplierManagement: {
        mySuppliersList: {
            api: '/api/odyssey/supplier-management/mysuppliers/list',
            method: 'GET',
            parameter: false
        },
        fetchSupplierDetails: {
            api: '/api/odyssey/supplier-management/supplierdetails',
            method: 'GET',
            parameter: false
        },
        fetchSupplierOrderList: {
            api: '/api/odyssey/supplier-management/fetchSupplierOrderList',
            method: 'GET',
            parameter: false
        },
        filterSuppliersByName: {
            api: '/api/odyssey/supplier-management/searchsupplier',
            method: 'GET',
            parameter: false
        },
        addSuppliers: {
            api : '/api/odyssey/supplier-management/addsupplier',
            method: 'GET',
            parameter: false
        },
        markSupplierAsPreferred: {
            api : '/api/odyssey/supplier-management/markpreferred',
            method: 'POST',
            parameter: false
        },
        deleteSupplier : {
            api : '/api/odyssey/supplier-management/deletesupplier',
            method: 'POST',
            parameter: false
        }
    },
    approvals : {
        fetchTransactionApprovalRequestsByStatus : {
            api: '/api/odyssey/orders/sales/list-by-status',
            method: 'GET',
            parameter: false
        },
        rejectPayment: {
            api: '/api/odyssey/orders/sales/reject',
            method: 'POST',
            parameter: false
        },
        approvePayment: {
            api: '/api/odyssey/orders/sales/approve',
            method: 'GET',
            parameter: false
        }
    }

};



// WEBPACK FOOTER //
// ./src/endpoints/odyssey.endpoints.ts